const apiUrl = process.env.REACT_APP_BACKEND_URL;

// BUILDING OPERATIONS
export const createBuilding = async (buildingData) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(buildingData)
  };

  const response = await fetch(`${apiUrl}api/buildings/building`, requestOptions);
  const data = await response.json();
  
  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Create building failed');
  }
  
  return data;
};

export const updateBuilding = async (buildingData) => {
  const requestOptions = {
    method: 'POST', 
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(buildingData)
  };

  const response = await fetch(`${apiUrl}api/buildings/building`, requestOptions);
  const data = await response.json();
  
  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Update building failed');
  }
  
  return data;
};

export const deleteBuilding = async (buildingId) => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(`${apiUrl}api/buildings/building/${buildingId}`, requestOptions);
  const data = await response.json();
  
  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Delete building failed');
  }
  
  return data;
};

// AREA OPERATIONS
export const createArea = async (areaData) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(areaData)
  };

  const response = await fetch(`${apiUrl}api/buildings/area`, requestOptions);
  const data = await response.json();
  
  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Create area failed');
  }
  
  return data;
};

export const updateArea = async (areaData) => {
  const requestOptions = {
    method: 'POST', // Using POST for both create/update as per your backend
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(areaData)
  };

  const response = await fetch(`${apiUrl}api/buildings/area`, requestOptions);
  const data = await response.json();
  
  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Update area failed');
  }
  
  return data;
};

// Save the devices added to and removed from one area.
export const updateAreaDevices = async (areaId, addedDeviceIds, removedDeviceIds = []) => {
  const response = await fetch(`${apiUrl}api/buildings/area/${areaId}/devices`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ added_device_ids: addedDeviceIds, removed_device_ids: removedDeviceIds }),
  });
  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Assign area devices failed');
  }

  return data;
};

export const deleteArea = async (areaId) => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(`${apiUrl}api/buildings/area/${areaId}`, requestOptions);
  const data = await response.json();
  
  // Check for HTTP errors or logical errors in the response
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || 'Delete area failed');
  }
  
  return data;
};
